import { render, staticRenderFns } from "./IdeaIsSafeSection.vue?vue&type=template&id=7abdfe0d&scoped=true"
import script from "./IdeaIsSafeSection.vue?vue&type=script&lang=js"
export * from "./IdeaIsSafeSection.vue?vue&type=script&lang=js"
import style0 from "./IdeaIsSafeSection.vue?vue&type=style&index=0&id=7abdfe0d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7abdfe0d",
  null
  
)

export default component.exports